import { render, staticRenderFns } from "./ObjectsModal.vue?vue&type=template&id=3732182a&"
import script from "./ObjectsModal.vue?vue&type=script&lang=js&"
export * from "./ObjectsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports